import httpClient from "../../clients/httpClient";
import {
    ExchangeImpersonationResponse,
    StartImpersonationResponse,
} from "../../interfaces/impersonation.interface";

// The httpClient response interceptor unwraps `response.data`, so the API
// envelope `{ data: { ... } }` is what callers receive. Following the existing
// service pattern (e.g. getLoggedInUserRequest), the generic is the inner
// payload and callers destructure a single `{ data }`.

export const startImpersonation = (tenantId: number) => {
    return httpClient.post<StartImpersonationResponse>(
        "/api/v1/admin/impersonation/start",
        { tenant_id: tenantId }
    );
};

export const exchangeImpersonationCode = (code: string) => {
    return httpClient.post<ExchangeImpersonationResponse>(
        "/api/v1/auth/impersonation/exchange",
        { code }
    );
};

export const exitImpersonation = () => {
    return httpClient.post("/api/v1/admin/impersonation/exit");
};
